//@flow
import * as React from 'react';
import classnames from 'classnames';
import dropdownTheme from './Dropdown.scss';
import { themr } from 'react-css-themr';
import { TooltipDiv } from 'common/components/core/wrappers/Div';
import Input from 'common/components/core/input';
import Menu from './Menu';
import { ListItemInnerComponent as ListItemInner } from './MenuList';
import isEmpty from 'lodash/isEmpty';

const inputFactory = ({
    InputInner = ListItemInner,
    InputComponent = Input
}) => {
    class DropdownInputComponent extends React.Component<$FlowFixMeProps> {
        render() {
            const {
                value,
                theme,
                className,
                onClick,
                selectedItem,
                placeholder,
                label,
                getTextRef,
                disabled,
                disabledTooltip,
                tooltipPosition,
                tooltipClassName,
                ...others
            } = this.props;
            return (
                <TooltipDiv
                    invert
                    tooltip={
                        disabled && disabledTooltip ? disabledTooltip : null
                    }
                    theme={theme}
                    className={classnames(theme.inputWrap, className, {
                        [theme.disabled]: disabled
                    })}
                    tooltipClassName={tooltipClassName}
                    tooltipPosition={tooltipPosition}
                    onClick={onClick}
                >
                    {label ? <div className={theme.label}>{label}</div> : null}
                    <InputComponent
                        value={value}
                        theme={theme}
                        disabled={disabled}
                        {...others}
                    >
                        {isEmpty(selectedItem) ? (
                            <div className={theme.placeholder}>
                                <span className={theme.text} ref={getTextRef}>
                                    {placeholder}
                                </span>
                            </div>
                        ) : (
                            <InputInner
                                getTextRef={getTextRef}
                                item={selectedItem}
                                theme={theme}
                            />
                        )}
                    </InputComponent>
                </TooltipDiv>
            );
        }
    }
    return DropdownInputComponent;
};

const DropdownInputTemplate = inputFactory({});
const defaults = {
    theme: dropdownTheme,
    Input: DropdownInputTemplate,
    Menu
};

const dropdownFactory = ({
    DropdownInput = defaults.Input,
    DropdownMenu = defaults.Menu,
    options = {}
}) => {
    const { theme: defaultTheme } = { ...defaults, ...options };

    class DropdownComponent extends React.Component<
        $FlowFixMeProps,
        $FlowFixMeState
    > {
        static defaultProps = {
            position: {
                vertical: 'bottom',
                horizontal: 'left'
            }
        };
        constructor(props) {
            super(props);
            this.state = {
                isOpen: false,
                style: {}
            };
        }

        toggleVisibility = e => {
            this.state.isOpen ? this.hide() : this.show(e);
        };

        hide = () => {
            this.setState({ isOpen: false });
        };
        show = event => {
            let positionTargetElement = event.currentTarget;
            if (this.props.positionTarget === 'text')
                positionTargetElement = this.getTextTarget();
            const style = this.getMenuStyle(positionTargetElement);
            this.setState({ isOpen: true, style });
        };
        getMenuStyle = element => {
            //eleent = Input element or text element
            const { overrideWidth, position } = this.props; //TODO move positining to a wrapper
            const {
                top,
                left,
                height,
                width
            } = element.getBoundingClientRect();
            const xOffset = window.scrollX || window.pageXOffset;
            const yOffset = window.scrollY || window.pageYOffset;
            const { vertical, horizontal } = position;
            let menuTop = top + height + yOffset;
            let menuLeft = left + xOffset;
            switch (vertical) {
                case 'top':
                    menuTop = top + yOffset;
                    break;
                case 'middle':
                    menuTop = top + height / 2 + yOffset;
                    break;
                case 'bottom':
                    menuTop = top + height + yOffset;
                    break;
                default:
                    break;
            }
            switch (horizontal) {
                case 'left':
                    menuLeft = left + xOffset;
                    break;
                case 'right':
                    menuLeft = left + width + xOffset;
                    break;
                case 'center':
                    menuLeft = left + width / 2 + xOffset;
                    break;
                default:
                    break;
            }
            const menuWidth = overrideWidth ? null : width;
            return {
                position: 'absolute',
                top: menuTop,
                left: menuLeft,
                width: menuWidth
            };
        };
        getSelectedItem = () => {
            for (const item of this.props.source) {
                if (item.value === this.props.value) return item;
            }
            return {};
        };
        onItemClick = (item, event) => {
            this.props.onChange && this.props.onChange(item, event);
            this.hide();
        };
        getDropdownContainer = ref => {
            this.menuContainer = ref;
        };
        getTextContainer = ref => {
            this.textContainer = ref;
        };
        getContainer = () => {
            return this.menuContainer;
        };
        getTextTarget = () => {
            return this.textContainer;
        };
        handleOutsideClick = e => {
            this.state.isOpen ? e.stopPropagation() : null;
            this.hide(e);
        };
        onEscape = e => {
            this.hide(e);
        };
        onFocus = e => {
            if (!this.state.isOpen) this.show(e);
            this.props.onFocus && this.props.onFocus(e);
        };
        render() {
            const {
                theme,
                transitionName,
                dropdownMenuClassName,
                dropdownClassName,
                disabled,
                className,
                ...others
            } = this.props;
            const { isOpen } = this.state;
            const selectedItem = this.getSelectedItem();
            const activeItem = this.getSelectedItem();
            const isItemSelected = selectedItem ? true : false;

            return (
                <div
                    className={classnames(theme.dropdown, {
                        [dropdownClassName]: dropdownClassName
                    })}
                >
                    <DropdownInput
                        {...others}
                        theme={theme}
                        className={classnames(theme.inputTemplate, className, {
                            [theme.dropdownOpen]: isOpen
                        })}
                        onClick={disabled ? null : this.toggleVisibility}
                        disabled={disabled}
                        readOnly
                        selectedItem={selectedItem}
                        value={selectedItem.value}
                        onFocus={this.onFocus}
                        getTextRef={this.getTextContainer}
                    />
                    <DropdownMenu
                        {...others}
                        transitionName={transitionName}
                        isOpen={isOpen}
                        isItemSelected={isItemSelected}
                        onEscape={this.onEscape}
                        handleClickOutside={this.handleOutsideClick}
                        handleInsideClick={this.handleInsideClick}
                        getMenuRef={this.getDropdownContainer}
                        getContainer={this.getContainer}
                        theme={theme}
                        selectedItem={selectedItem}
                        activeItem={activeItem}
                        onItemClick={this.onItemClick}
                        style={this.state.style}
                        className={classnames(theme.dropdownMenu, {
                            [dropdownMenuClassName]: dropdownMenuClassName
                        })}
                    />
                </div>
            );
        }
    }
    return themr('CustomDropdown', defaultTheme)(DropdownComponent);
};

export default dropdownFactory({});
export { dropdownFactory };
